
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link } from '@ta-interaktiv/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Wer sich mit dem neuen Coronavirus infiziert, ist vor allem kurz vor dem Ausbruch und zu Beginn der Krankheit am ansteckendsten – in dieser Zeit wurden die meisten Virusmengen im Körper gefunden. In `}<Link disco href='https://www.medrxiv.org/content/10.1101/2020.03.05.20030502v1' allowWordWrap mdxType="Link">{`einer Studie mit neun Patienten`}</Link>{` wurde die Ausscheidungsdynamik vermehrungsfähiger Viren untersucht. `}<strong parentName="p">{`Abstrichproben vom Rachen enthielten vermehrungsfähige Viren bis zum vierten Tag nach Symptombeginn, aus dem Auswurf bis zum achten Tag nach Symptombeginn. Weder im Stuhl noch im Urin oder Serum konnten vermehrungsfährige Viren nachgewiesen werden.`}</strong>{` Sobald die Produktion von Antikörpern einsetzt, sinkt die Infektiosität der Erkrankten schnell. «Covid-19-Erkrankte können nach etwa 10 Tagen nach Ausbruch der Krankheit keine anderen Menschen mehr infizieren», sagt Ali Khan, Dekan des College of Public Health am medizinischen Zentrum der Universität von Nebraska in Omaha.`}</p>
    <p>{`Eine andere `}<Link disco href='https://www.nature.com/articles/s41586-020-2196-x_reference.pdf' mdxType="Link">{`Studie`}</Link>{` kam zu ähnlichen Resultaten. `}<strong parentName="p">{`Die höchsten Virenmengen von Sars-CoV-2 wurden im Rachen von Patienten noch vor dem Tag 5 nach Ausbruch der Krankheit gefunden, und sie waren bis zu Tausend Mal grösser als bei der Lungenkrankheit Sars.`}</strong>{` Die Forscher kommen deshalb zum Schluss, dass Sars-CoV-2 viel einfacher übertragen werden kann als damals Sars und vor allem zu einem Zeitpunkt, wenn die Symptome zu Beginn der Krankheit noch mild sind.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;